import { PageLayout } from '~/shared/ui/PageLayout/PageLayout';

import { useLocalization } from '../localization/localization';

import { Description, Root } from './Error.ui';
import AlertLogo from './images/alert.svg';

export const ErrorPage = () => {
  const { t } = useLocalization();

  return (
    <PageLayout>
      <Root>
        <AlertLogo />
        <Description>{t('title')}</Description>
      </Root>
    </PageLayout>
  );
};
